<template>
  <div>
    <div class="tab-wrap clearfix">
      <router-link v-for="(item,index) in menus" :key="index" tag="li" :to="item.path" :class="{'active':active(item.path)}" @click.native="check(item.path)">{{item.name}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFoot',
  data () {
    return {
      activeIndex: 1,
      menus: [
        { path: '/', name: '设备控制' },
        { path: '/equipmentExhibition', name: '设备展示' },
        { path: '/electricityStatistics', name: '电力统计' },
        { path: '/deviceSettings', name: '设备设置' }
      ]
    }
  },
  methods: {
    active (path) {
      return this.$route.path === path
    },
    check (path) {
      if (path === '/electricityStatistics') {
        this.$Alert.info({
          content: '电力统计正在建设中',
          duration: 3000,
          status: 'error'
        })
      }
      if (path === '/deviceSettings') {
        this.bus.$emit('checkPath', false)
      } else {
        this.bus.$emit('checkPath', true)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.tab-wrap
  position fixed
  bottom 0
  width 100%
  background rgba(22,75,153,.3);
  li
    float left
    width 25%
    line-height 48px
    text-align center
    list-style none
    cursor pointer
    font-size 20px
    color #BBD4E9
  .active
    color #fff
    font-size 20px
    background linear-gradient(0deg,rgba(0,84,255,1),rgba(24,149,255,1))
    text-shadow:0px 2px 0px rgba(0,43,116,0.32);
</style>
